<div class="auth-wrapper auth-v2">
<app-language-selector></app-language-selector>
  <div class="auth-inner max-width row m-0">
    <!-- Left Text-->
    <div class="d-flex align-items-center p-5 l-side">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-3">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/register-v2-dark.svg'
              : 'assets/images/register-2.svg'
          "
          alt="Register V2"
        />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Register-->
    <div class="d-flex align-items-center auth-bg r-side">
      <div class="mx-auto login-form">
        <div class="company-logo" *ngIf="logo">
          <img src="{{logo}}" alt="">
        </div>
        <h2 class="card-title mb-1">Sa incepem!</h2>
        <p class="card-text mb-2">Verifica ca datele tale sunt corecte si apasa continua ! Daca datele personale nu sunt corecte te rugam sa iti anunti compania sa solicite modificarea acestora.</p>
        <form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
              <label for="register-name" class="form-label">Nume prenume</label>
              <input
                      type="text"
                      formControlName="name"
                      class="form-control"
                      placeholder="johndoe"
                      aria-describedby="register-name"
                      tabindex="1"
                      autofocus
                      [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
              />
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                  <div *ngIf="f.name.errors.required">Name is required</div>
              </div>
          </div>

          <div class="form-group">
            <label for="register-cnp" class="form-label">CNP</label>
            <input
                    type="number"
                    formControlName="cnp"
                    class="form-control"
                    placeholder="0000000000000"
                    aria-describedby="register-cnp"
                    tabindex="2"
                    autofocus
                    [ngClass]="{ 'is-invalid': submitted && f.cnp.errors }"
            />
            <div *ngIf="submitted && f.cnp.errors" class="invalid-feedback">
                <div *ngIf="f.cnp.errors.required">Cnp is required</div>
            </div>
        </div>

        <div class="form-group">
          <label for="register-city" class="form-label">Oras</label>
          <input
                  type="text"
                  formControlName="city"
                  class="form-control"
                  placeholder="Oras"
                  aria-describedby="register-city"
                  tabindex="3"
                  autofocus
                  [ngClass]="{ 'is-invalid': submitted && f.city.errors }"
          />
          <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
              <div *ngIf="f.city.errors.required">city is required</div>
          </div>
        </div>

        <div class="form-group">
          <label for="register-phone" class="form-label">Numar de telefon</label>
          <input
                  type="number"
                  formControlName="phone"
                  class="form-control"
                  placeholder="0700000000"
                  aria-describedby="register-phone"
                  tabindex="4"
                  autofocus
                  [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"
          />
          <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
              <div *ngIf="f.phone.errors.required">phone is required</div>
          </div>
        </div>
          <!-- <div class="form-group">
              <label for="register-email" class="form-label">Adresă email</label>
              <input
                      type="text"
                      formControlName="email"
                      class="form-control"
                      placeholder="john@example.com"
                      aria-describedby="register-email"
                      tabindex="2"
                      [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
              />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">Email is required</div>
                  <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
              </div>
          </div>

          <div class="form-group">
              <label for="register-password" class="form-label">Seteaza-ti parola</label>

              <div class="input-group input-group-merge form-password-toggle">
                  <input
                          [type]="passwordTextType ? 'text' : 'password'"
                          formControlName="password"
                          class="form-control form-control-merge"
                          placeholder="············"
                          aria-describedby="register-password"
                          tabindex="3"
                          [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                  />

              </div>
              <div
                      *ngIf="submitted && f.password.errors"
                      class="invalid-feedback"
                      [ngClass]="{ 'd-block': submitted && f.password.errors }"
              >
                  <div *ngIf="f.password.errors.required">Password is required</div>
              </div>
              <span class="p-required r1"><i class="fa fa-check-circle-o"></i>Cel putin 8 caractere</span>
              <span class="p-required r2"><i class="fa fa-check-circle-o"></i>Un simbol sau un numar</span>

          </div>

          <div class="form-group">
              <label for="register-repet-password" class="form-label">Repeta parola</label>

              <div class="input-group input-group-merge form-password-toggle">
                  <input
                          [type]="passwordTextType ? 'text' : 'password'"
                          formControlName="password"
                          class="form-control form-control-merge"
                          placeholder="············"
                          aria-describedby="register-repet-password"
                          tabindex="3"
                          [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                  />

              </div>
              <div
                      *ngIf="submitted && f.password.errors"
                      class="invalid-feedback"
                      [ngClass]="{ 'd-block': submitted && f.password.errors }"
              >
                  <div *ngIf="f.password.errors.required">Password is required</div>
              </div>
          </div>
          <div class="form-group">
              <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" id="register-privacy-policy" tabindex="4" />
                  <label class="custom-control-label" for="register-privacy-policy">
                      sunt de acord cu <a href="javascript:void(0);" class="c-company">termenii si conditiile</a>
                  </label>
              </div>
          </div> -->
          <button class="btn btn-primary btn-block"
                  tabindex="5"
                  rippleEffect>
              <i class="fa fa-arrow-right"></i>
              Intra in cont
          </button>
      </form>
      </div>
    </div>
    <!-- /Register-->
  </div>
</div>
